module.exports = __webpack_public_path__ + "media/images/svg/tick-75df39cf44d83cc27532912223e94f49.svg";